import { flushSync } from 'react-dom'

export function replaceMinimizedListingForm({ displacedEntry, onOpen }) {
  flushSync(() => {
    displacedEntry.onForceClose?.()
  })

  onOpen()
}
